import React from 'react';
import PropTypes from 'prop-types';

import BackToConversation from './backToConversation.jsx';
import DetailsFooter from './detailsFooter.jsx';

const Page = ({ children, heading }) => (
    <div className="r-pbl r-ptm">
        <BackToConversation />
        <div className="r-mtm centerify">
            <div className="r-size3of5 inlineblockify">
                <h1 className="t2 r-pbm">{heading}</h1>
                <div className="leftify">{children}</div>
                <DetailsFooter />
            </div>
        </div>
    </div>
);

Page.propTypes = {
    children: PropTypes.node,
    heading: PropTypes.string,
};

export default Page;



// WEBPACK FOOTER //
// ./safeTrade/page.jsx